import App, { AppProps } from "next/app";
import React from "react";
import dynamic from "next/dynamic";
import router, { withRouter } from "next/router";
import Head from "next/head";
import { Store } from "redux";
import isMobile from "@utils/isMobile";
// import Theme from "@components/theme";
import "@public/css/rc-slider/index.css";

import "@public/css/system.css";
import "../styles/tailwind.css";
import Context from "@components/useContext/context";
import withRedux from "@store/index";
import indexModule from "@store/indexModule";
import LandingPageConfig, {
  bikeWidgetBasePath
} from "@utils/landing-page-config";
// import sentry from "@utils/sentry";
import { debounce } from "@utils/lodash";
// import getHeaders from "@utils/getHeaders";
// import { Header } from "@components/newCar/checkout/mobile/review/styles";
// const { captureException } = sentry();
import { getPlatform, isJourneyFlow } from "@components/utils/utils";
import { captureExceptions } from "@utils/sentry";
import { checkIsPartnerFlow } from "@utils/index";
import Cookies from "js-cookie";
// import { abExperiments } from "@utils/abExperiments";

import {
  AckoMainTheme,
  ThemeProvider
} from "@acko-tech/building-blocks.ui.theme";
import Hotjar from "@hotjar/browser";
import segmentsModule from "segments";
import growthbook from "@utils/growthbook";
// import { initAckoAnalytics } from "@acko-tech/building-blocks.ui.acko-analytics";
import { getProductEnum } from "@utils/productEnum";
import { getAppData } from "@store/indexModule/actions";
import { initAckoAnalytics } from "@acko-tech/building-blocks.ui.acko-analytics";
import axios from "axios";
import Chatbot from "@components/chatbot";
import { getRegexData } from "@utils/getRegexData";
import { getUrlWithQueryUtmParamsServer } from "@utils/utm";
import { initDatadogRum } from "@utils/initDatadogRum";
import "@public/css/Euclid.css";
import {
  getTurnstileConfig,
  isTurnstileEnabledForProduct
} from "@utils/turnstile/config";
import { isTurnstileProtectedCreateProposalPage } from "@utils/turnstile/protectedPages";
import { preloadTurnstile } from "@utils/turnstile/turnstile";
// import { carInsuranceStartingPriceBasePath } from "@utils/landing-page-config";

// const { captureException } = sentry();

// const NavigationLoader = dynamic(
//   () => import("@components/common/mobile/navigationLoader"),
//   { ssr: false }
// );

const ToastWrap = dynamic(() => import("@components/ToastWrap"), {
  ssr: false
});

const ToastWrapV2 = dynamic(() => import("@components/ToastV2"), {
  ssr: false
});

interface Props {
  store: Store;
  basePath: string;
  isMobile: boolean;
  headers: any;
  isNewCar: boolean;
  abVersions: any;
  product: any;
  isBike: boolean;
  trackerid: string;
  xRootPath: string;
}

process.env.ENVIRONMENT?.toLowerCase() === "production" && process?.browser
  ? (console.log = () => {})
  : null;
const getTurnstileProductFromPath = (path?: string, product?: string) => {
  const normalizedProduct = (product || "").toLowerCase();
  if (normalizedProduct.includes("bike")) return "bike";
  if (normalizedProduct.includes("car")) return "car";

  const normalizedPath = (path || "").toLowerCase();
  if (normalizedPath.includes("/bike")) return "bike";
  if (normalizedPath.includes("/car")) return "car";

  return undefined;
};

class StoreApp extends App<Props & AppProps, {}, {}> {
  state = {
    mobile: null,
    amazonPrime: false,
    mobileNumber: "",
    isFlutterInAppWebViewReady: false,
    growthBookLoaded: false
  };

  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};
    const reqHeaders = {};
    let isNewCar = false;
    const abVersions = {};
    let product: string | null = "";
    let isBike = false;
    let trackerid = "";
    let xRootPath = "";
    try {
      if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(ctx);
      }
      const { store } = ctx;
      const { indexReducer } = store.getState();
      const { appDataLoaded, isFetchingAppData } = indexReducer || {
        appDataLoaded: null
      };
      const isMobileValue = isMobile(ctx.req);
      if (ctx.req) {
        xRootPath = ctx.req.headers["x-root-path"];
      } else {
        xRootPath = window.xRootPath;
      }
      if (ctx?.req) {
        // checking if we need to redirect to SDUI flow
        // const journeyVersion = ctx.req?.cookies?.journey_version;
        const proposalId = ctx.query.proposal_id;
        const isCarJourney = ctx?.req?.url?.includes("gi/car-journey/nsr");
        if (isCarJourney && proposalId) {
          const res = await axios({
            url: `${process.env.MO_BASE_SERVICE}/proposals/journey_version/${proposalId}`,
            method: "GET"
          });
          const { data } = res;

          if (data?.journey_version === "v3") {
            const location = getUrlWithQueryUtmParamsServer({
              url: `${process.env.HOST_URL}/gi/auto-storefront/fresh-car`,
              ctx,
              queryParams: {
                proposal_ekey: proposalId,
                current_node: "entry_node",
                registration_number: data?.registration_number
              }
            });
            ctx?.res?.writeHead(302, {
              Location: location
            });
            ctx?.res?.end();
          }
        }

        // let cookieArray: Array<string> = [];
        // abExperiments.forEach(exp => {
        //   const cookie_name = exp.name;
        //   // console.log({ cookie_name }, { idx });
        //   if (exp.isActive) {
        //     const cookie_val =
        //       ctx.req?.cookies[cookie_name] ??
        //       (function() {
        //         const abVersion = generateRandomNumber(exp);
        //         cookieArray.push(`${cookie_name}=${abVersion};path=/`);
        //         return abVersion;
        //       })();
        //     abVersions[cookie_name] = cookie_val;
        //   } else {
        //     abVersions[cookie_name] = 0;
        //     cookieArray.push(
        //       `${cookie_name}=${0};path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC`
        //     );
        //   }
        // });
        // ctx?.res?.setHeader("set-cookie", cookieArray);
      }
      // } else {
      // abExperiments.forEach(exp => {
      //   abVersions[exp.name] = exp.isActive
      //     ? Cookies.get(exp.name)
      //     : exp.default;
      // });
      // }

      // If required to be used on server, we can set this(isNewCar) value in context
      if (ctx?.req?.url && ctx?.req?.url?.includes("/new-car/")) {
        isNewCar = true;
      }

      // we can have all product enum on the server
      if (ctx?.req) {
        product = getProductEnum(ctx);
      } else {
        product = window.product;
      }

      if (
        ctx?.pathname?.includes("/bike-journey/") ||
        (ctx?.pathname?.includes("/renew-policy") &&
          ctx?.query?.product === "bike")
      ) {
        isBike = true;
      }

      if (
        ctx?.req &&
        !ctx?.req?.url?.includes("js.map") &&
        !appDataLoaded &&
        isFetchingAppData !== true &&
        !ctx?.req?.url?.includes(process.env.STATIC_ASSETS)
      ) {
        const { getAppPlatform } = await import("@store/indexModule/actions");
        store.dispatch(
          getAppPlatform({ platform: getPlatform(isMobileValue) })
        );
      }

      if (
        ctx?.req &&
        (ctx?.req?.url?.includes("/car-journey/") ||
          ctx?.req?.url?.includes("/renew-policy") ||
          ctx?.req?.url?.includes("/widgets/"))
      ) {
        const regexData = await getRegexData();
        const { getRegexDataSuccess } = await import("@store/regex/actions");
        store.dispatch(getRegexDataSuccess(regexData));
      }

      if (!ctx?.req) {
        isNewCar = window.isNewCar;
        // isBike = window.isBike;
      }

      if (ctx?.req && isJourneyFlow(ctx?.req?.url)) {
        console.log("request url:", ctx?.req?.url);
        trackerid = ctx.req.headers["x-encrypted-tracker-id"];
        if (!trackerid)
          console.log(
            "Error setting tracker id for:",
            JSON.stringify(ctx.req.headers),
            ctx?.req?.url
          );
      }

      if (!ctx?.req) {
        trackerid = Cookies.get("trackerid") || "";
        let user_id = (Cookies.get("trackerid") || "").split(":")[0];
        growthbook.setAttributes({
          id: trackerid,
          user_id
        });
      }

      return {
        pageProps,
        isMobile: isMobileValue,
        headers: reqHeaders,
        abVersions,
        isNewCar,
        product,
        isBike,
        trackerid,
        xRootPath
      };
    } catch (error) {
      console.error("in app err", error);
      return {
        isMobile: isMobile(ctx.req),
        hasError: true,
        errorEventId: 0, // errorEventId,
        headers: reqHeaders,
        abVersions,
        pageProps,
        product,
        trackerid
      };
    }
  }

  componentDidCatch(error) {
    captureExceptions(error, {
      extra: {
        appError: true
      }
    });
  }

  componentDidMount() {
    window.addEventListener(
      "resize",
      debounce(() => {
        const isMobile = window.innerWidth < 767 ? true : false;
        if (this.state.mobile != isMobile) this.setState({ mobile: isMobile });
      }, 100)
    );
    window.platform = getPlatform(!window.isDesktop);
    window.addEventListener("flutterInAppWebViewPlatformReady", () => {
      //not to fire bridging events in case of partners
      if (!checkIsPartnerFlow())
        this.setState({ isFlutterInAppWebViewReady: true });
    });

    router.events.on("routeChangeComplete", this.handleRouteChangeComplete);
    this.preloadTurnstileForCurrentRoute(this.props.router?.asPath);
    this.hotjarInitialise();
    // ignore third party errors
    const response: {
      amazon_prime: string;
      phone: string;
    } = this.props.store.dispatch(getAppData());
    this.setState({
      amazonPrime: response?.amazon_prime || "",
      mobileNumber: response?.phone || ""
    });

    growthbook.setAttributes({
      id: Cookies.get("trackerid"),
      user_id: (Cookies.get("trackerid") || "").split(":")[0]
    });
    growthbook.loadFeatures();

    initDatadogRum().catch(err => {
      console.error("[Datadog RUM] async init error", err);
    });
  }

  componentWillUnmount() {
    router.events.off("routeChangeComplete", this.handleRouteChangeComplete);
  }

  preloadTurnstileForCurrentRoute = (path?: string) => {
    if (!isTurnstileProtectedCreateProposalPage(path)) {
      return;
    }

    const turnstileConfig = getTurnstileConfig();
    const product = getTurnstileProductFromPath(
      path,
      this.props.product ||
        (typeof window !== "undefined" ? window.product : "")
    );
    if (!isTurnstileEnabledForProduct(product, turnstileConfig)) {
      return;
    }

    preloadTurnstile(turnstileConfig).catch(error => {
      console.error("[Turnstile] preload failed", error);
    });
  };

  handleRouteChangeComplete = (url?: string) => {
    //CHECKING PAYLOAD
    window.wisepops && window.wisepops("pageview");
    this.preloadTurnstileForCurrentRoute(url);
  };

  getHotjarSiteId = url => {
    const siteIdFreshCar = parseInt(process.env.HOTJAR_SITE_ID || "0");
    const siteIdRenewalCar = parseInt(process.env.HOTJAR_RENEWAL_SITEID || "0");
    const siteIdBikeMigration = parseInt(process.env.HOTJAR_BIKE_SITEID || "0");
    const siteIdNewCar = parseInt(process.env.HOTJAR_NEW_CAR_SITEID || "0");

    switch (true) {
      case url.includes("/car-journey/"):
        return siteIdFreshCar;
      case url.includes("/renew-policy"):
        return siteIdRenewalCar;
      case url.includes("/bike-journey/"):
        return siteIdBikeMigration;
      case url.includes("/inspection/"):
        return siteIdNewCar;
      default:
        return null;
    }
  };

  hotjarInitialise = () => {
    const { router } = this.props;

    const hotjarVersion = 6;
    const siteId = this.getHotjarSiteId(router?.asPath);
    if (process.env.NODE_ENV === "production" && siteId) {
      Hotjar.init(siteId, hotjarVersion);
    }
  };

  render() {
    const {
      Component,
      pageProps,
      basePath,
      router,
      isMobile,
      isNewCar,
      abVersions,
      product,
      isBike,
      trackerid,
      xRootPath
    } = this.props;
    const { STATIC_ASSETS } = process.env;
    const { query } = router;
    let lpSource = query?.lpSource || "";

    if (typeof window !== "undefined") {
      if (xRootPath) {
        window.xRootPath = xRootPath;
      }
      const { route, asPath } = router;
      let asPathWithoutQueryParams = asPath.split("?")[0];
      if (asPathWithoutQueryParams[asPathWithoutQueryParams.length - 1] !== "/")
        asPathWithoutQueryParams += "/";
      let path: any = route.split("/[")[0];
      path = path === "/" || !path ? null : `${path}/`;
      //  for landing pages
      window.basePath =
        (Object.keys(LandingPageConfig).includes(
          this.props.router?.asPath.split("?")[0]
        ) &&
          this.props.router?.asPath.split("?")[0]) ||
        // for entry points passing source in query
        lpSource ||
        // For partner widget bike
        (route === bikeWidgetBasePath
          ? LandingPageConfig[bikeWidgetBasePath]?.source
          : "");
      window.isDesktop = !isMobile;
      window.isNewCar = isNewCar;
      if (!!product) {
        window.product = product;
      }
      window.isBike = isBike;
    }

    const prodBasePath =
      typeof window !== "undefined" ? window.basePath : basePath;
    const basePathValue =
      process.env.USE_ENV_BASE_PATH === "true"
        ? process.env.DEV_BASE_PATH
        : prodBasePath;

    let gtagUrl = STATIC_ASSETS
      ? `${STATIC_ASSETS}/js/googleOptimize/gtag.js`
      : "/js/googleOptimize/gtag.js";
    let gtmHeadUrl = STATIC_ASSETS
      ? `${STATIC_ASSETS}/js/gtm/head.js`
      : "/js/gtm/head.js";
    gtagUrl = gtagUrl;
    gtmHeadUrl = gtmHeadUrl;

    const isGpay = basePathValue?.includes("/gpay-bike");
    const enableSpot = process.env.ENABLE_GPAY_SPOT === "true";
    const isProductionEnv =
      process.env.ENVIRONMENT?.toLowerCase() === "production";
    return (
      <>
        <Context.Provider
          value={{
            basePath: basePathValue,
            isAmazonPrime: this.state.amazonPrime,
            isDesktop:
              this.state.mobile !== null ? !this.state.mobile : !isMobile,
            authorizedMobileNumber: this.state.mobileNumber,
            isNewCar: isNewCar,
            isFlutterInAppWebViewReady: this.state.isFlutterInAppWebViewReady,
            abVersions,
            product,
            isBike: isBike,
            isGpay,
            showChatbot: true,
            canRenderHelp: true
          }}
        >
          <ThemeProvider theme={AckoMainTheme}>
            <div style={{ background: isMobile ? "#f4f5f6" : "white" }}>
              <Head>
                <meta name="robots" content="noindex" />
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
                />

                <link
                  rel="dns-prefetch"
                  href={
                    process.env.ENVIRONMENT === "PRODUCTION"
                      ? "//storefront.ackoassets.com"
                      : "//storefront-dev.ackoassets.com"
                  }
                />
                <link
                  rel="dns-prefetch"
                  href="https://www.googletagmanager.com/"
                />
                <link rel="dns-prefetch" href="https://edge.fullstory.com/" />
                <link
                  rel="dns-prefetch"
                  href="https://www.googleadservices.com/"
                />
                <link
                  rel="dns-prefetch"
                  href="https://www.google-analytics.com/"
                />
                <link rel="dns-prefetch" href="https://connect.facebook.net/" />

                <title>
                  Quick Car & Two Wheeler Insurance Policy Online - ACKO General
                  Insurance Company
                </title>

                <script
                  src="/p/acko-assist/api/public/copilot-v1.js"
                  id="copilot"
                  defer
                />

                {enableSpot && (
                  <script
                    type="text/javascript"
                    src="https://checkout.razorpay.com/v1/razorpay.js"
                    async
                  />
                )}
                {enableSpot && (
                  <script
                    src="https://microapps.google.com/apis/v1alpha/microapps.js"
                    async
                  />
                )}
                <script>dataLayer = [];</script>
                <script type="basepath-data">{basePathValue}</script>
                <script src={gtagUrl} type="text/javascript" defer />
                <script src={gtmHeadUrl} type="text/javascript" defer />
                {isProductionEnv && (
                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: `
                        (function(c,l,a,r,i,t,y){
                            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        })(window, document, "clarity", "script", "xpdkc88u9e");
                      `
                    }}
                  />
                )}
                {/* inject segment script only when we have tracker id */}
                {(trackerid || Cookies.get("trackerid")) && (
                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: initAckoAnalytics(
                        trackerid || Cookies.get("trackerid"),
                        process.env.SEGMENT_KEY || ""
                      )
                    }}
                  ></script>
                )}
              </Head>
              {/* <NavigationLoader /> */}
              <Component {...pageProps} isMobile={isMobile} />
              <Chatbot />
              <ToastWrap />
              <ToastWrapV2 />
              {/* {process.env.ENVIRONMENT === "PRODUCTION" ? (
                  <script
                    id="_webengage_script_tag"
                    src="/js/webengage/prod.js"
                    type="text/javascript"
                    defer
                  />
                ) : (
                  <script
                    id="_webengage_script_tag"
                    src={`${STATIC_ASSETS}/js/webengage/uat.js`}
                    type="text/javascript"
                    defer
                  /> */}
              {/* )} */}
              <script
                src="https://www.googletagmanager.com/gtag/js?id=UA-92272448-1"
                type="text/javascript"
                defer
              />
              <script
                src={`${STATIC_ASSETS}/js/googleOptimize/gtag.js`}
                type="text/javascript"
                defer
              />
              <script
                src={`${STATIC_ASSETS}/js/gtm/head.js`}
                type="text/javascript"
                defer
              />
            </div>
          </ThemeProvider>
        </Context.Provider>
      </>
    );
  }
}

export default withRedux(withRouter(StoreApp), [
  indexModule(),
  segmentsModule()
]);
